// Required for tailwindcss to work
import "@/styles/index.css";

import React from "react";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QUERY_STALE_TIME_MS } from "@/lib/utils/queryUtils";
import { scheduleIdle } from "@/lib/utils/scheduleIdle";
import { routeTree } from "./routeTree.gen";

function RouterPendingComponent() {
  return (
    <div id="initial-loader">
      <div className="spinner" />
    </div>
  );
}

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: QUERY_STALE_TIME_MS,
  defaultStaleTime: QUERY_STALE_TIME_MS,
  scrollRestoration: true,
  scrollToTopSelectors: ["#main-scrollable-area"],
  defaultPendingComponent: RouterPendingComponent,
  defaultPendingMs: 400,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("app")!;

const root = ReactDOM.createRoot(rootElement);
root.render(
  <ErrorBoundary>
    <RouterProvider router={router} />
  </ErrorBoundary>,
);

scheduleIdle(() => {
  void import("@/lib/sentry").then(({ initSentry }) => {
    void initSentry(router);
  });
});
